export default "__VITE_ASSET__CZlyNJIK__"